import { asyncToGenerator as _asyncToGenerator, objectSpread2 as _objectSpread2 } from "../_virtual/_rollupPluginBabelHelpers.js";
import _pt from 'prop-types';
import { createContext } from 'react';
import { CachePolicies, Provider } from 'use-http';
import { deepMapKeysToCamelCase } from '@appfolio/js-data-mapper';
import { Helmet } from 'react-helmet';
import BaseResource from "../hooks/api/resources/BaseResource.js";
import { jsx } from '@emotion/core';
var ConfigsContext =
/*#__PURE__*/
createContext(null);
var defaultUseFetchOptions = {
  cachePolicy: CachePolicies.NO_CACHE,
  interceptors: {
    // TODO: add request inteceptor to convert to snakecase
    response: function () {
      var _response2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(_ref) {
        var _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _response = _ref.response;

                if (_response.data) {
                  _response.data = deepMapKeysToCamelCase(_response.data);
                }

                return _context.abrupt("return", _response);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function response(_x) {
        return _response2.apply(this, arguments);
      }

      return response;
    }()
  }
};

function DocumentsAppConfigsProvider(_ref2) {
  var children = _ref2.children,
      configs = _ref2.configs,
      useFetchOptions = _ref2.useFetchOptions;
  BaseResource.apiNamespace = configs.apiPrefix;
  return jsx(ConfigsContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, configs), {}, {
      experiments: new Set(configs.experiments)
    })
  }, jsx(Helmet, null, jsx("link", {
    rel: "preconnect",
    href: "https://fonts.gstatic.com"
  }), jsx("link", {
    href: "https://fonts.googleapis.com/css2?family=Cookie&display=swap",
    rel: "stylesheet"
  }), jsx("link", {
    href: "https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300&display=swap",
    rel: "stylesheet"
  })), jsx(Provider, {
    options: _objectSpread2(_objectSpread2({}, defaultUseFetchOptions), useFetchOptions)
  }, children));
}

DocumentsAppConfigsProvider.displayName = "DocumentsAppConfigsProvider";
DocumentsAppConfigsProvider.propTypes = {
  configs: _pt.shape({
    currentUserId: _pt.string.isRequired,
    currentUserPermissions: _pt.arrayOf(_pt.string),
    apiPrefix: _pt.string.isRequired,
    experiments: _pt.arrayOf(_pt.string)
  }).isRequired,
  children: _pt.node.isRequired
};
export default ConfigsContext;
export { DocumentsAppConfigsProvider, defaultUseFetchOptions };